import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

import point from './point';
import exchange from './exchange';
import userInfo from './userInfo';
import modal from './modal';

Vue.use(Vuex);

const defaultState = {
  isLogin: false,
  serviceUrl: null,
  serviceInfo: null,
  pointThumbnailList: [],
  pointList: [],
  exchangeLayerUrl: '',
  isExchangeIframe: false,
  telNoFrontList: [
    '010',
    '070',
    '02',
    '031',
    '032',
    '033',
    '041',
    '042',
    '043',
    '044',
    '051',
    '052',
    '053',
    '054',
    '055',
    '061',
    '062',
    '063',
    '064',
  ],
};

export default new Vuex.Store({
  state: defaultState,
  getters,
  actions,
  mutations,
  modules: {
    point,
    exchange,
    userInfo,
    modal,
  },
});
